<div class="row" >
  <div class="col-sm-12">
    <div class="content-header">Enrollment Form</div>
  </div>
</div>
<section id="ngx" >
  <div class="card">
    <div class="card-content">
      <div class="card-body">
        <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
          <aw-wizard-step [stepTitle]="'Step 1'" [navigationSymbol]="{
              symbol: '&#xf007;',
              fontFamily: 'FontAwesome'
            }">
            <form #studentForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Student Information</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="name">Name<span class="required_field">*</span></label>
                        <fieldset class="position-relative has-icon-right">
                          <input class="form-control input-md" [(ngModel)]="enrolmentModel.name" ngModel #name="ngModel"
                            required  id="name" name="name" type="text" (ngModelChange)="onNameChange($event)" />
                          <div class="form-control-position">
                            <a [href]="
                                'student-edit/' + enrolmentModel.user_id._id
                              " target="_blank"><i class="cursor ft-edit"></i></a>
                          </div>
                          <small
                              class="form-text text-muted danger"
                              *ngIf="
                                !name.valid && (name.dirty || name.touched)
                              "
                              >Name is required!</small>
                        </fieldset>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mt-3">
                      <div class="form-group">
                        <!-- <label class="form-control-label mb-1" for="college"
                          >College
                          <div
                            *ngIf="selectedCollege"
                            class="custom-switch custom-control-inline mb-1 mb-xl-0"
                          >
                            <input
                              type="checkbox"
                              (change)="
                                updateBusiness(
                                  selectedCollege,
                                  checkIfCollegeActivated(selectedCollege)
                                    ? false
                                    : true
                                )
                              "
                              class="custom-control-input cursor"
                              id="custom-switch-1"
                              [checked]="
                                checkIfCollegeActivated(selectedCollege)
                              "
                            />
                            <label
                              class="custom-control-label mr-1"
                              for="custom-switch-1"
                            >
                              <span>{{
                                checkIfCollegeActivated(selectedCollege)
                                  ? "Activated"
                                  : "Deactivated"
                              }}</span>
                            </label>
                          </div>
                        </label> -->
                        <fieldset class="position-relative has-icon-right">
                          <ng-select [items]="collegeList" bindLabel="name" bindValue="_id" placeholder="Select College"
                            [(ngModel)]="selectedCollege" [ngModelOptions]="{ standalone: true }"
                            (change)="getCollegeId($event)" #college="ngModel">
                            <ng-template ng-header-tmp>
                              <div>
                                <button class="btn btn-link" (click)="goToPage()">
                                  <!-- (click)="openContent(1)" -->

                                  Add New College
                                </button>
                              </div>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                              <img height="15" width="15" [src]="item.avatar" />
                              <span [style.color]="
                                  !item.is_activated ? 'red' : 'black'
                                ">{{ item.name }}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="selectedCollege" class="form-control-position">
                            <a [href]="'business/edit/' + selectedCollege" target="_blank"><i
                                class="cursor ft-edit"></i></a>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="email">Email<span class="required_field">*</span></label>
                        <fieldset class="position-relative has-icon-right">
                          <input class="form-control input-md" [(ngModel)]="enrolmentModel.email" ngModel
                            #email="ngModel" required email id="email" name="email" type="text"  (ngModelChange)="onEmailChange($event)" />
                          <div class="form-control-position">
                            <a [href]="
                                'student-edit/' + enrolmentModel.user_id._id
                              " target="_blank"><i class="cursor ft-edit"></i></a>
                          </div>
                          <small
                              class="form-text text-muted danger"
                              *ngIf="
                                !email.valid && (email.dirty || email.touched)
                              "
                              >Email is required!</small>
                          <!-- <small *ngIf="checkEmailPhone(enrolmentModel.email,'');emailAlreadyExist">Email is already exists</small> -->
                        </fieldset>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="phone">Phone Number</label>
                        <fieldset class="position-relative has-icon-right">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">+91</span>
                            </div>
                            <input class="form-control input-md" [(ngModel)]="enrolmentModel.phone" #phone="ngModel"
                              required id="phone" name="phone" type="text" placeholder="e.g. (555) 555 5555"
                              mask="(000) 000-0000" minlength="10"/>
                          </div>
                          <div class="form-control-position">
                            <a [href]="
                                'student-edit/' + enrolmentModel.user_id._id
                              " target="_blank"><i class="cursor ft-edit"></i></a>
                          </div>
                          <!-- <small class="form-text text-muted danger" *ngIf="checkEmailPhone('',enrolmentModel.phone)">{{phoneAlreadyExist}}</small> -->

                        </fieldset>
                      </div>
                      <!-- <div class="form-group">
                        <label>Checklist</label>
                        <ng-select
                        [items]="list_type"
                        bindLabel="name"
                        bindValue="_id"
                        [closeOnSelect]="false"
                        placeholder="Select Checklist"
                        [(ngModel)]="selected_check_list"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getCheckListId($event)"
                      ></ng-select>
                      </div> -->
                    </div>
                    <!-- <div class='col-12 col-sm-6'>
                                            <div class="form-group">
                                                <label class="form-control-label" for="last_qualification">Last Qualification</label>
                                                <input class="form-control input-md" [(ngModel)]="enrolmentModel.last_qualification" ngModel #last_qualification="ngModel" required id="last_qualification" name="last_qualification" type="text">
                                                <small class="form-text text-muted danger" *ngIf="!last_qualification.valid && (last_qualification.dirty || last_qualification.touched)">last_qualification number is required!</small>
                                            </div>
                                        </div> -->
                  </div>

                  <div class="form-group text-center">
                    <button [disabled]="!name.valid || !email.valid" type="button" uiSref="work" class="btn btn-info" awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 2'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #learningForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Learning Interest</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="categoryInterest">Category Interest<span class="required_field">*</span></label>
                        <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                          placeholder="Select Course Category Interest" [(ngModel)]="selectedCategory"
                          [ngModelOptions]="{ standalone: true }" (change)="getCategoryId($event)"
                          #courseCategory="ngModel">
                        </ng-select>
                        <small
                              class="form-text text-muted danger"
                              *ngIf="
                                !courseCategory.valid && (courseCategory.dirty || courseCategory.touched)
                              "
                              >Category Interest is required!</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="skills">Skills</label>
                        <ng-select [items]="skillList" bindLabel="displayname" bindValue="_id" [multiple]="true"
                          [closeOnSelect]="false" placeholder="Select Skills" [(ngModel)]="skillTags"
                          [ngModelOptions]="{ standalone: true }">
                        </ng-select>
                      </div>
                    </div>
                    <!-- <div class='col-12 col-sm-6'>
                                            <div class="form-group">
                                                <label class="form-control-label" for="number">Phone Number</label>
                                                <input class="form-control input-md" ngModel #number="ngModel" required id="number" name="number" type="text">
                                                <small class="form-text text-muted danger" *ngIf="!number.valid && (number.dirty || number.touched)">This field is required!</small>
                                            </div>
                                        </div> -->
                  </div>

                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button type="button" (click)="createEnrolment()" uiSref="work" class="btn btn-info" [disabled]="!courseCategory.valid"
                      awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                  <!-- <div class="form-group text-center">
                                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                                        <span style="margin-right:10px;">
                                            <i class="ft-chevron-left"></i>
                                        </span> Previous</button>
                                    <button uiSref="result" type="button" class="btn btn-success" [disabled]="!personalForm.valid" awResetWizard>
                                        Finish
                                        <span style="margin-left:10px;">
                                            <i class="ft-chevron-right"></i>
                                        </span>
                                    </button>
                                </div>
   -->
                  <!-- <div class="form-group text-center">
                                        <button type="button" uiSref="work" class="btn btn-info" [disabled]="!personalForm.valid" awNextStep>
                                            Next
                                            <span style="margin-left:10px;">
                                                <i class="ft-chevron-right"></i>
                                            </span>
                                        </button>
                                    </div> -->
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 3'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #internalForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Internal Records</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="huntingBy">Hunting by<span class="required_field">*</span></label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Hunting By"
                          [(ngModel)]="selectedHuntingBy" [ngModelOptions]="{ standalone: true }"
                          (change)="getHuntId($event)" #huntingBy="ngModel">
                        </ng-select>
                        <small
                              class="form-text text-muted danger"
                              *ngIf="
                                !huntingBy.valid && (huntingBy.dirty || huntingBy.touched)
                              "
                              >Hunting by is required!</small>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="farmingBy">Farming by<span class="required_field">*</span></label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Farming By"
                          [(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }"
                          (change)="getFarmId($event)" #farmingBy="ngModel">
                        </ng-select>
                        <small
                        class="form-text text-muted danger"
                        *ngIf="
                          !farmingBy.valid && (farmingBy.dirty || farmingBy.touched)
                        "
                        >Farming by is required!</small>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="goal">Goal<span class="required_field">*</span></label>
                        <ng-select [items]="goalList" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Goal" [(ngModel)]="goal" [ngModelOptions]="{ standalone: true }" (change)="getGoalId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label>Learning Mode<span class="required_field">*</span></label>
                        <ng-select [items]="learningList" bindLabel="displayname" bindValue="_id"
                          placeholder=" Select Mode" [(ngModel)]="selectLearningMode"
                          [ngModelOptions]="{ standalone: true }" (change)="getModeId($event)" #mode="ngModel">
                        </ng-select>
                        <small
                        class="form-text text-muted danger"
                        *ngIf="
                          !mode.valid && (mode.dirty || mode.touched)
                        "
                        >Learning mode is required!</small>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="team">Team<span class="required_field">*</span></label>
                        <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Team" [(ngModel)]="team" [ngModelOptions]="{ standalone: true }" (change)="getTeamId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">Agency<span class="required_field">*</span></label>
                        <ng-select [items]="agency_List" bindLabel="name" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Agency" [(ngModel)]="agency" [ngModelOptions]="{ standalone: true }" (change)="getAgencyId($event)">
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      
                      <div class="form-group">
                        <label>Next Action</label>
                        <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id"       placeholder="Select next action"
                          [(ngModel)]="enrolmentModel.next_action" [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label>Last Response</label>
                        <input type="text" class="form-control" [(ngModel)]="enrolmentModel.lastresponse" [ngModelOptions]="{standalone: true}" placeholder="Enter Last Response" >
                      </div>
                      <div class="form-group">
                        <label>Last Active Date</label>
                        <input type="date" class="form-control" [(ngModel)]="enrolmentModel.last_activedate" [ngModelOptions]="{standalone: true}" placeholder="Enter Date" >
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="notes">Documents & Incentives</label>
                        <textarea class="form-control input-md" [(ngModel)]="enrolmentModel.notes" ngModel
                           name="notes" id="notes" cols="30" rows="5"></textarea>
                        <!-- <small class="form-text text-muted danger"
                          *ngIf="!notes.valid && (notes.dirty || notes.touched)">notes is required!</small> -->
                      </div>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button [disabled]="!internalForm.valid" type="button" uiSref="work" class="btn btn-info"
                      awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 4'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #enrollmentForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Enrolment</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="course">Course<span class="required_field">*</span></label>
                        <ng-select [items]="courseList" bindLabel="title" bindValue="_id" placeholder="Select Course"
                          [(ngModel)]="selectedCourse" ngModel #course="ngModel" required name="course"
                          [ngModelOptions]="{ standalone: true }" required course id="course"
                          (change)="getCourseId($event)" #Course>
                            <!-- Custom template to show both title and description -->
  <ng-template ng-option-tmp let-item="item">
    {{ item.title }} | {{ item.duration?.displayname }}
  </ng-template>
                        </ng-select>
                        <small class="form-text text-muted danger" *ngIf="
                            !course.valid && (course.dirty || course.touched)
                          ">course is required!</small>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">Mentor</label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id"
                          placeholder="Select Mentor" [(ngModel)]="selected_mentor" [ngModelOptions]="{ standalone: true }"
                          (change)="getMentorId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">Buddy</label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id"
                          placeholder="Select Buddy" [(ngModel)]="selected_buddy" [ngModelOptions]="{ standalone: true }"
                          (change)="getBuddyId($event)">
                        </ng-select>
                      </div>
                      
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="batch">Batch</label>
                        <ng-select [items]="batchList" bindLabel="name" bindValue="_id"
                          placeholder="Select Batch" [(ngModel)]="selectedBatch" [ngModelOptions]="{ standalone: true }"
                          (change)="getBatchId($event)">
                          <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-link" (click)="openContent(2)">
                                Add New Batch
                              </button>
                            </div>
                          </ng-template> -->
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="batch">Batch Schedule</label>
                        <ng-select [items]="batchSchedule_list" bindLabel="displayname" bindValue="_id"
                          placeholder="Select Batch Schedule" [(ngModel)]="selectedBatch_schedule" [ngModelOptions]="{ standalone: true }"
                          (change)="getBatchScheduleId($event)">
                          <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-link" (click)="openContent(2)">
                                Add New Batch
                              </button>
                            </div>
                          </ng-template> -->
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="course">Date Of Joining</label>
                        <input type="date" name="enrolmentModel.date_of_joining" class="form-control input-md" [(ngModel)]="enrolmentModel.date_of_joining"
                          [ngModel]="enrolmentModel.date_of_joining | date: 'yyyy-MM-dd'" [disabled]="false">
                      </div>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button [disabled]="!course.valid" type="button" uiSref="work" class="btn btn-info" awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 5'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #feesForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Fees</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="total_fees">Total Fees</label>
                        <input type="text" class="form-control input-md" [(ngModel)]="enrolmentModel.total_fees" ngModel
                          #total_fees="ngModel" name="total_fees" id="total_fees" readonly />
                        <small class="form-text text-muted danger" *ngIf="
                            !total_fees.valid &&
                            (total_fees.dirty || total_fees.touched)
                          ">Total Fees is required!</small>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="net_fees">Net Fees</label>
                        <input type="text" class="form-control input-md" [(ngModel)]="enrolmentModel.net_fees"
                          #net_fees="ngModel" name="net_fees" id="net_fees"/>
                        <small class="form-text text-muted danger" *ngIf="
                            !net_fees.valid &&
                            (net_fees.dirty || net_fees.touched)
                          ">net fees is required!</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="discount">Discount</label>
                        <ng-select [items]="discountList" bindLabel="name" bindValue="_id" [multiple]="true"
                          placeholder="Select Discount" [(ngModel)]="selectedDiscount"
                          [ngModelOptions]="{ standalone: true }" (change)="getDiscountId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="discount_amounts">Paying Amount</label>
                        <input type="number" class="form-control input-md" [(ngModel)]="paid_amount" ngModel
                          #payable_amount="ngModel" name="payable_amount" />
                        <small class="form-text text-muted danger" *ngIf="
                            !payable_amount.valid &&
                            (payable_amount.dirty || payable_amount.touched)
                          ">payable amount is required!</small>
                      </div>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button type="button" uiSref="work" class="btn btn-info" [disabled]="!feesForm.valid" awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 6'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #registrationForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Registration</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="notes">Payment Description</label>
                        <textarea class="form-control input-md" [(ngModel)]="enrolmentModel.admin_notes" ngModel
                          #admin_notes="ngModel" name="admin_notes" id="admin_notes" cols="30" rows="8"></textarea>
                        <!-- <small
                          class="form-text text-muted danger"
                          *ngIf="!admin_notes.valid && (admin_notes.dirty || admin_notes.touched)"
                          >adminnotes is required!</small -->
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="status">Payment Status</label>
                        <ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name"
                          placeholder="Select Status" [(ngModel)]="selectedPaymentStatus"
                          [ngModelOptions]="{ standalone: true }">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="status">Payment Mode</label>
                        <ng-select [items]="paymentMode" bindLabel="displayname" bindValue="_id"
                          placeholder="Select Payment Mode" [(ngModel)]="selectedPaymentMode"
                          [ngModelOptions]="{ standalone: true }" (change)="getPaymentModeId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label for="next_payment_date">Next payment date</label>
                        <input type="date" class="form-control" [(ngModel)]="enrolmentModel.next_payment_date" ngModel
                          #next_payment_date="ngModel" min="{{ min_next_payment_date }}" name="next_payment_date"
                          id="next_payment_date" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button uiSref="result" (click)="submit()" type="button" class="btn btn-success" awResetWizard>
                      Finish
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
        </aw-wizard>
      </div>
    </div>
  </div>
</section>